import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import { ProgramConfig } from 'source/js/common/constants/appConstants'
import { useTheme } from 'styled-components/native'

import { Appointment } from '@lyrahealth-inc/shared-app-logic/src/models/appointment/Appointment'
import { ClientObject } from '@lyrahealth-inc/shared-app-logic/src/models/client/Client'
import { Link } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/link/Link'
import { InlineInfoBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/inlineInfoBanner/InlineInfoBanner'
import { InlineWarningBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/inlineWarningBanner/InlineWarningBanner'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { useIsEngageDAProvider } from '../../../hooks/useIsEngageDAProvider'

type BillingImplicationsMessageProps = {
  appointment: Appointment
  clientDetails: ClientObject
  programConfig: ProgramConfig | undefined
}

export const BillingImplicationsMessage: FunctionComponent<BillingImplicationsMessageProps> = ({
  appointment,
  clientDetails,
  programConfig,
}) => {
  const intl = useIntl()
  const { colors } = useTheme()
  const isProviderEngageDA = useIsEngageDAProvider()

  if (isProviderEngageDA) {
    const message = intl.formatMessage(
      {
        defaultMessage:
          'You are about to close session {sessionNumber} for {clientName}. ' +
          'This action has billing implications for clients and customers. ' +
          'Learn more about our',
        description: 'Billing implications message for Engage DA providers',
      },
      {
        sessionNumber: appointment.sessionNumber,
        clientName: clientDetails.first_name,
      },
    )
    return (
      <InlineInfoBanner
        backgroundColor={colors.backgroundSection}
        textColor={colors.textSecondary}
        iconColor={colors.iconDefault}
        iconSize={24}
        text={message}
        trailingLink={
          <Link
            text={'program session closure policy.'}
            onPress={() => window.open(programConfig?.sessionClosureGuide, '_blank')}
            testID={tID(`EndOfSession-sessionClosurePolicyLink`)}
            size={BodyTextSize.DEFAULT}
          />
        }
      />
    )
  }

  return (
    <InlineWarningBanner
      text={
        <>
          You are about to close session {appointment.sessionNumber} for {clientDetails.first_name}. This action has
          billing implications for clients and customers.{' '}
          <Link
            text={'Learn more about program session closure policy.'}
            onPress={() => window.open(programConfig?.sessionClosureGuide, '_blank')}
            testID={tID(`EndOfSession-sessionClosurePolicyLink`)}
            size={BodyTextSize.DEFAULT}
          />
        </>
      }
    />
  )
}
